<template>
  <v-main>
    <v-card rounded="xl" color="rgb(255, 255, 255, 0.2)">
      <v-card-title>Find out which movies actors have shared</v-card-title>
      <v-card-text>
        <v-form color="primary">
          <label v-if="!firstActorId">Enter first actor name</label>
          <v-text-field
            v-if="!firstActorId"
            autocomplete="off"
            filled
            outlined
            v-model="firstActor"
          />

          <Autocomplete
            v-if="!firstActorId"
            v-on:name="setFirstName"
            v-on:id="setFirstId"
            :term="firstActor"
            :actor="firstActorId"
          />
          <label v-if="!secondActorId">Enter second actor name</label>
          <v-text-field
            v-if="!secondActorId"
            filled
            outlined
            v-model="secondActor"
          />
          <Autocomplete
            v-if="!secondActorId"
            v-on:name="setSecondName"
            v-on:id="setSecondId"
            :term="secondActor"
            :actor="secondActorId"
          />
          <v-alert v-if="error" type="error"
            >You need to choose 2 actors from the drop down for this to
            work...</v-alert
          >
          <div style="display: flex; justify-content: space-around">
            <ActorCard
              v-on:id="
                firstActorId = null;
                firstActor = '';
                jointMovies = [];
              "
              v-if="firstActorId"
              :actorId="firstActorId"
            />
            <ActorCard
              v-on:id="
                secondActorId = null;
                secondActor = '';
                jointMovies = [];
              "
              v-if="secondActorId"
              :actorId="secondActorId"
            />
          </div>
          <v-btn
            :disabled="!firstActorId || !secondActorId"
            dark
            @click="submit"
            >Submit</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>

    <v-container grid-list-xl>
      <v-layout class="centre" wrap>
        <v-card class="no-results" v-if="noMovies">
          <v-card-title> These 2 aren't in any movies together! </v-card-title>
        </v-card>
        <v-flex
          auto
          xs12
          sm6
          md3
          mb-2
          v-for="item in jointMovies"
          :key="item.id"
        >
          <MovieCard :movie="item" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import environment from "../../env";
import Autocomplete from "./Autocomplete";
import ActorCard from "./ActorCard";
import MovieCard from "./MovieCard";

export default {
  components: {
    Autocomplete,
    ActorCard,
    MovieCard,
  },
  data: function () {
    return {
      firstActor: "",
      secondActor: "",
      firstActorId: 0,
      secondActorId: 0,
      jointMovies: [],
      noMovies: false,
      error: false,
    };
  },
  methods: {
    setFirstName(name) {
      this.firstActor = name;
    },
    setSecondName(name) {
      this.secondActor = name;
    },
    setFirstId(name) {
      this.firstActorId = name;
    },
    setSecondId(name) {
      this.secondActorId = name;
    },
    submit() {
      this.error = false;
      console.log("peopleId", this.firstActorId, this.secondActorId);
      if (this.firstActorId && this.secondActorId) this.getJointMovies();
      if (!this.firstActorId || !this.secondActorId) this.error = true;
    },
    getJointMovies() {
      console.log("first actor id ", this.firstActorId);
      console.log("second actor id", this.secondActorId);
      axios
        .get(
          `https://api.themoviedb.org/3/discover/movie?api_key=${environment.APIKEY}&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&with_cast=${this.firstActorId},${this.secondActorId}`
        )
        .then((res) => {
          this.jointMovies = [];
          console.log(res);
          if (res.data.total_results == 0) {
            this.noMovies = true;
          } else {
            this.jointMovies = [];
            this.noMovies = false;
            res.data.results.forEach((item) => {
              this.jointMovies.push({
                title: item.title,
                overview: item.overview,
                poster:
                  "https://image.tmdb.org/t/p/original/" + item.poster_path,
                year: item.release_date.substring(0, 4),
                rating: item.vote_average * 10,
              });
            });
          }
        });
    },
  },
};
</script>

<style >
.v-card__title {
  word-break: normal; /* maybe !important  */
}
.v-card__text,
.flexcard {
  display: flex;
  flex-direction: column;
}
.centre {
  justify-content: center;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background-color: rebeccapurple;
}
.flexcard:hover .overlay {
  opacity: 1;
}
.text {
  width: 90%;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
  overflow-y: auto;
}
</style>